import React, { useEffect } from "react";
import useState from "react-usestateref";
import * as Icons from "@material-ui/icons";
import Pagination from "@material-ui/lab/Pagination";
import { Typography, Button, CircularProgress } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
import moment from "moment";
import PdfImage from "../images/PDF_file_icon.svg.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";

function Internapplyerlist() {
  const [currentPage, setCurrentPage] = useState(1);
  const [interApplyers, setinterApplyers, interApplyersref] = useState([]);
  const [totalPage, setTotalpages] = useState(0);
  const [activefilter, setActivefilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [toDate, setToDate] = useState("");
  var classes = useStyles();
  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const handlePageChange = (pageNumber) => {
    getinternslist(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };
  const [pageloader, setpageLoader] = useState(true);
  useEffect(() => {
    getinternslist();
  }, []);

  const getinternslist = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      };

      var data = {
        apiUrl: apiService.get_beleaf_inter_list,
        payload: payload,
      };

      setpageLoader(true);
      var resp = await postMethod(data);
      setpageLoader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setinterApplyers(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const handleExportCourseContacts = async () => {
    try {
      if (!activefilter) {
        const response = await postMethod({
          apiUrl: apiService.exportinternContactList,
          payload: {},
        });

        if (response.success && response.data) {
          const data = response.data;
          console.log(data, "data===");

          const formattedData = data.map((item, index) => ({
            Name: item.internerName || "-",
            College: item.internerCollege || "-",
            "Looking For": item.internerLookingFor || "-",
            City: item.internerCity || "-",
            "Mobile Number": item.internermobileValue || "-",
            "Created At": item.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(formattedData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Intern Applyers List",
          );

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(blob, "Intern_Applyers_List.xlsx");
        } else {
          alert("No data available for export.");
        }
      } else {
        const data = interApplyersref.current || [];

        const formattedData = data.map((item, index) => ({
          Name: item.internerName || "-",
          College: item.internerCollege || "-",
          "Looking For": item.internerLookingFor || "-",
          City: item.internerCity || "-",
          "Mobile Number": item.internermobileValue || "-",
          "Created At": item.createdAt
            ? new Date(item.createdAt).toLocaleString()
            : "-",
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Intern Applyers List",
        );

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Intern_Applyers_List.xlsx");
      }
    } catch (error) {
      console.error("Export failed", error);
      alert("Failed to export Intern Applyers List.");
    }
  };

  const enquiry = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "read",
      };
      var data = {
        apiUrl: apiService.changestatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        getinternslist();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };

  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getinternslist(1);
  };

  return (
    <>
      {/* {pageloader == true ? (
        <>
          {" "}
          <div className="loader">
            <CircularProgress />
          </div>
        </>
      ) : ( */}
      <div>
        <div className={`${classes.jobApplyer_div} mb-4 flex-wrap`}>
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Beleaf Internship Applyers List
          </Typography>
          <div className="right_top">
            {" "}
            <SearchBar
              placeholder="Search by Name"
              className="mb-3"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
            />
            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />
            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />
            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
            <Button
              className={classes.btn_export}
              variant="outlined"
              color="primary"
              onClick={handleExportCourseContacts}
            >
              <i class="fas fa-file-excel"></i> Export
            </Button>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table className="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>College</th>
                  <th>Looking For</th>
                  <th>City</th>
                  <th>Mobile Number</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : interApplyersref.current &&
                  interApplyersref.current.length > 0 ? (
                  interApplyersref.current.map((item, i) => (
                    <tr key={item._id || i}>
                      <td>{i + 1}</td>
                      <td>{item.internerName || "-"}</td>
                      <td>{item.internerCollege || "-"}</td>
                      <td>{item.internerLookingFor || "-"}</td>
                      <td>{item.internerCity || "-"}</td>
                      <td>{item.internermobileValue || "-"}</td>
                      <td>
                        {item.createdAt
                          ? moment(item.createdAt).format("lll")
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="no-record">
                    <td colSpan={9}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* <Pagination
        itemClass="page-item" // add it for bootstrap 4
        linkClass="page-link" // add it for bootstrap 4
        activePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
      </div>
      {/* )} */}
    </>
  );
}

export default Internapplyerlist;
